import * as api from '@tytapp/api';
import { Model } from '@tytapp/common';

@Model('Show')
export class Show extends api.ApiShow {
    static API = api.ShowsApi;
    static ROOT_URL = '/content/shows';

    public get url() {
        return `/shows/${this.id}`;
    }
}
